import { useState } from "react";
import Header from "../Header";

const GST = () => {
    const [formData, setFormData] = useState({
        month: ''       
    });
    const role = localStorage.getItem('role');
    const id = localStorage.getItem('userId');

    const [successMessage, setSuccessMessage] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value }); // Fixed state update
    };   

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            ...formData,
            role: role,
            mgr_id: id
        };
        try {
            const response = await fetch("https://apiaksharaconnect.aksharafinalytics.in/GSTSMS", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });
            // const data = await response.json();
            // console.log("Response: ", data);
            setFormData({ month: '' });
            setSuccessMessage("Message Sent Successfully");
        } catch (error) {
            //console.error("Error submitting form: ", error);
            setSuccessMessage('Somthing went worng, please Try agin');
        }
    };

    return (
        <>
            <Header />
            <div className="container mt-5">
            {successMessage && <div className="alert alert-success text-center">{successMessage}</div>}
                <div className="card shadow">
                    
                    <div className="card-header">
                        <h2>GST Message</h2>
                    </div>
                    
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <input type="hidden" name="role" value={role}/>
                            <input type="hidden" name="mgr_id" value={id}/>
                            <div className="mb-3">
                                <label className="form-label">Select Month</label>
                                <select  className="form-control" name="month" value={formData.month}  onChange={handleChange} required>
                                    <option value="">--  Month ---</option>
                                    <option value="January">January</option>
                                    <option value="February">February</option>
                                    <option value="March">March</option>
                                    <option value="April">April</option>
                                    <option value="May">May</option>
                                    <option value="June">June</option>
                                    <option value="July">July</option>
                                    <option value="August">August</option>
                                    <option value="September">September</option>
                                    <option value="October">October</option>
                                    <option value="November">November</option>
                                    <option value="December">December</option>
                                </select>
                            </div>
                            
                            <center>
                                <button type="submit" className="btn btn-primary">
                                    Send Message
                                </button>
                            </center>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GST;
